import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ContentService } from '../_core';
// import { TypeJobListingFields } from '../content-types';

import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { LottiePlayer } from "@lottiefiles/lottie-player";


import { Entry } from 'contentful';
import { LcpHelper } from '../_core/_helpers/lcp-helper';





@Component({
  selector: 'app-homepage-v1',
  templateUrl: './homepage-v1.component.html',
  styleUrls: ['./homepage-v1.component.scss']
})
export class HomepageV1Component implements OnInit, AfterViewInit {

  @ViewChild('heroMessageLine1') heroMessageLine1: ElementRef
  @ViewChild('heroMessageLine2') heroMessageLine2: ElementRef

  @ViewChild('homeServicesTabContent') homeServicesTabContent: ElementRef

  // @ViewChildren(CollapsableContentComponent) collapsableContent !: QueryList<CollapsableContentComponent>
  @ViewChildren('lottiePlayer') lottiePlayers: QueryList<LottiePlayer>
  @ViewChildren('lottiePlayerContainer') lottiePlayerContainers: QueryList<LottiePlayer>



  content: any
  fields: any

  bannerImage: any
  heroMessage: any
  heroMessages: any[]
  // jobListings: Entry<TypeJobListingFields>[] | undefined;
  // fields: any

  taglineUppercase: boolean = true
  taglineLowercase: boolean = false

  shouldAnimateTagline: boolean = true;
  shouldDisplayTagline: boolean[] = [true, false]
  // shouldDisplayTaglineCursor2: boolean = true

  initialTaglineIndex: number
  animationFiles: any[]
  animationData: any = {}

  animations: any
  serviceSelected: string // content.slug
  serviceActive: string

  // animationOptions: AnimationOptions = {
  //   path: '/assets/animation.json',
  // };

  constructor(
    public cdr: ChangeDetectorRef,
    public contentService: ContentService,
    public lcpHelper: LcpHelper,

    // public lottieInteractivity: LottieInteractivity
  ) { }

  ngOnInit(): void {
    this.getHomepage()

    // console.log('lp', LottiePlayer)
  }

  ngAfterViewInit(): void {
    // this.animateTagline(this.fields['heroMessages'], "#tagline")
    this.initAnimations()
    // console.log('afterView', this.lottiePlayers)
  }

  getHomepage(){
    // this.contentService.getHomepage()
    this.contentService.getPage({'fields.slug': 'home-v1' })
    .subscribe({
       next: (content) => {
        // console.log('CONTENT', content)
        this.content = content
        this.fields = this.content.items[0].fields
        this.bannerImage = 'https:' + this.fields['banner'][0].fields.file.url
        // console.log('fields', this.fields, this.heroMessageLine1);
        this.heroMessages = this.fields['heroMessages']
        // this.getAnimationFiles()
        // console.log('hero-messages', this.fields['heroMessages']);
        this.detectChanges()

        if (!this.heroMessages) return
        // this.initialTaglineIndex = this.lcpHelper.getRandomInt(this.heroMessages.length)
        // this.animateTagline(this.heroMessages[this.initialTaglineIndex], this.heroMessageLine1)
        this.animateTaglines(this.heroMessages)
       }
   });
  }

  initAnimations() {
    // console.log('init anim', this.lottiePlayers.toArray())

    let lottieElements = document.getElementsByClassName('lottie-player')
    // console.log('lottie-elements', lottieElements)

  }

  initScrollAnimation(el: any, index: string) {
    console.log('initScrollAnimation', el, this.lottiePlayers.toArray())
    // window.setTimeout(() => { el.stop() }, 2000)
    console.log('tot-frames', el.getLottie().totalFrames)
    this.initIntersectionObserver(el, index)
  }


  percentageSequence(keys = 100) {
    let scale = keys/100
    let sequence = Array.from(Array(keys).keys()).map(i => parseFloat(((i+1) * (0.01 / scale)).toFixed(3)))
    // console.log('percentageSequence', sequence)
    return sequence
  }

  initIntersectionObserver(el: any, index: string) {
    const observer = new IntersectionObserver( 
      ([e]) => {
        // let lottie = el.getLottie()
        // let frame = Math.floor(e.intersectionRatio * (el.getLottie().totalFrames - 1))
        let lottie = this.getLottieFromIndex(index)
        if (!lottie) return console.log('ERR: initIntersectionObserver !lottie')

        let frame = Math.floor(e.intersectionRatio * (this.getLottieFromIndex(index).totalFrames - 1))

        // DEBUGGING (keep)
        // if (Array.from(el.classList).indexOf('lottie-player_1_0') > -1) {
        //   console.log('IR:', el.id, e.intersectionRatio, frame)
        // }
        
        el.seek(frame)
      },

      // ([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1), 
      { rootMargin: '300px 0px -200px 0px',
        threshold: this.percentageSequence(150) }
    );

    console.log('scroll-inter', el)
    observer.observe(el)
  }

  getLottieFromIndex(index: string) {
    let className = `lottie-player_${index}`
    let firstElement = document.getElementsByClassName(className)[0]
    let lottie = (firstElement as any).getLottie()
    // console.log('lpfi', index, lottie, firstElement)
    return lottie
  }

  getAnimationDataString(file: any) {
    let title = this.animationTitle(file)
    this.getAnimationData(file)
      .then((raw: any) => {
        //  console.log('raw', raw)
         return JSON.stringify(raw)
      })
      .then((data: any) => {
        // let data = require(file)
        let parsed = JSON.parse(data)
        // console.log('anim data', typeof data, title, parsed)
        this.animationData[title] = data
        return data
      })
    // this.animationData[title] = data
    // return data
  }

  animationTitle(file: any) {
    return file['fileName'].split(".")[0]
  }

  getAnimationData(file: any): Promise<any> {
    if (file['contentType'] != 'application/json') return Promise.resolve()

    let title = this.animationTitle(file)
    if (this.animationData[title]) return this.animationData[title]
    if (this.animationData[title] == false) {
      return new Promise(resolve => setTimeout(this.getAnimationData.bind(this, file), 1000));
      // return delay(1000).then(this.getAnimationData(file))
    }
    // console.log('GAD', title, file['fileName'], file)
    this.animationData[title] = false
    return fetch("https://" + file.url)
      .then(res => {
        // console.log('GAD', res.json())
        return res.json()
      })
      // {
      //   // console.log('res', res.json())
      //   return res.json()
      // })
  }

  animationSrc(file: any) {
    let src = "https://" + file.url
    console.log('src', src)
    return src
  }

  // TAGLINE ANIMATION
  
  // async animateTagline(heroMessage: any, el: ElementRef) {
  //   console.log('hm', heroMessage)
  //   await this.typeSentence(heroMessage.fields['text'], el, { delay: 100 })
  //   await this.waitForMs(500)
  //   await this.updateTaglineCursor(false)
  //   await this.highlightContent(el, { delay: 10 })
  //   await this.waitForMs(500)
  //   await this.updateTaglineStyle('lowercase')
  //   // await this.waitForMs(100)
  //   await this.removeTaglineHighlight(el)
  //   await this.waitForMs(300)
  //   await this.updateTaglineCursor(true)
  // }

  async animateTaglines(heroMessages: any[]) {
    // console.log('hero-messages', heroMessages)
    // this.heroMessageLine1
    await this.typeSentence(heroMessages[0].fields['text'], this.heroMessageLine1, { delay: 100 })
    await this.updateTaglineCursor([false, true])
    await this.typeSentence(heroMessages[1].fields['text'], this.heroMessageLine2, { delay: 100 })
    // await this.updateTaglineCursor([false, true])
    await this.waitForMs(500)
    // await this.updateTaglineCursor([true, false])
    await this.highlightContent(this.heroMessageLine2, { delay: 10 })
    await this.waitForMs(500)
    await this.updateTaglineStyle('lowercase')
    // await this.waitForMs(100)
    await this.removeTaglineHighlight(this.heroMessageLine2)
    await this.waitForMs(300)
    await this.updateTaglineCursor([false, false])
  }

  // async animateTagline(heroMessage: any, el: ElementRef) {
  //   await this.typeSentence(heroMessage.fields['text'], el, { delay: 100 })
  //   await this.waitForMs(500)
  //   await this.updateTaglineCursor(false)
  //   await this.highlightContent(el, { delay: 10 })
  //   await this.waitForMs(500)
  //   await this.updateTaglineStyle('lowercase')
  //   // await this.waitForMs(100)
  //   await this.removeTaglineHighlight(el)
  //   await this.waitForMs(300)
  //   await this.updateTaglineCursor(true)
  // }

  // async loopTagline(heroMessages: any, el: ElementRef) {
  //   var i = this.lcpHelper.getRandomInt(this.heroMessages.length) // 0;
  //   while(this.shouldAnimateTagline = true) {
  //     // await this.animateTagline(this.heroMessages[i], el)
  //     await this.waitForMs(2000)
  //     await this.deleteSentence(el)
  //     await this.waitForMs(100)
  //     await this.updateTaglineStyle('uppercase')
      
  //     i++
  //     if( i >= heroMessages.length ) i = 0
  //   }
  // }
  

  async typeSentence(sentence: any, el: ElementRef, params={}) {
    // @ts-ignore
    let delay = params['delay'] || 100
    const letters = sentence.split("");
    let i = 0;
    while(i < letters.length) {
      let randomizedDelay = Math.max(Math.random() * delay, 10);
      // console.log('randy', randomizedDelay)
      await this.waitForMs(randomizedDelay);
      this.typeLetter(el, letters[i])
      // $(el).append(letters[i]);
      i++
    }
    return;
  }

  typeLetter(el: ElementRef, letter: string) {
    // let el = this.createElement('span', letter)
    if (!this.shouldAnimateTagline) return

    el.nativeElement.insertAdjacentHTML('beforeend', '<span>' + letter + '</span>');
  }

  createElement(type: string, innerHtml='') {
    let el = document.createElement(type);
    // el.classList.add(cssClass);
    el.innerHTML = innerHtml;
    return el
  }
  
  async highlightContent(el: ElementRef, params={}) {
    if (!this.shouldAnimateTagline) return

    // const sentence = $(el).html();
    let highlightClass = "hi"
    let ne = el.nativeElement
    // console.log('chil', ne.children)
    let children = ne.children
    let arr = Array.from(children) as Array<any>;
    // @ts-ignore
    let delay = params['delay'] || 10
    // let innerHtml = ne.innerHTML;
    // const letters = innerHtml.split("<span>");
    // console.log('letters', letters)

    // const letters = sentence.split("");
    let i = 0;
    let firstHighlightedIndex: number = 1000

    while(firstHighlightedIndex > 0) {
      await this.waitForMs(delay);
      // arr.pop();
      firstHighlightedIndex = arr.findIndex((span:any) => {
        return span.classList.contains(highlightClass)
      })
      if (firstHighlightedIndex == -1) firstHighlightedIndex = arr.length as number

      // console.log('fhi', arr, firstHighlightedIndex, arr.length)
      let newHi = arr[firstHighlightedIndex - 1]
      if (newHi) newHi.classList.add(highlightClass)
      // console.log('new-arr', arr)
      let outerArr = arr.map((span:any) => span.outerHTML)
      let joined = outerArr.join("")
      // console.log('joined', joined, joined || "<p></p>")
      ne.innerHTML = joined || "<span> </span>";
      
      // $(el).html(letters.join(""));
    }
  }

  removeTaglineHighlight(el: ElementRef) {
    if (!this.shouldAnimateTagline) return

    // const sentence = $(el).html();
    let highlightClass = "hi"
    let ne = el.nativeElement
    let children = ne.children
    let arr = Array.from(children) as Array<any>;
    // @ts-ignore
    let i = 0;
    let firstHighlightedIndex: number = 1000

    let unHighlighted = arr.map(span => span.classList.remove(highlightClass))
    // console.log('unh-1', unHighlighted)
    let outerArr = arr.map((span:any) => {
      return span.outerHTML
    })
    let joined = outerArr.join("")
    // console.log('unh', unHighlighted, joined, joined || "<p></p>")
    ne.innerHTML = joined || "<span> </span>";
  }



  updateTaglineStyle(state: string) {
    if (!this.shouldAnimateTagline) return

    this.taglineLowercase = state == 'lowercase'
    this.taglineUppercase = state == 'uppercase'
    // console.log('update case', state)
  }

  updateTaglineCursor(data: boolean[]) {
    this.shouldDisplayTagline = data
  }

  async deleteSentence(el: ElementRef) {
    if (!this.shouldAnimateTagline) return
    let ne = el.nativeElement
    // console.log('chil', ne.children)
    let children = ne.children
    let arr = Array.from(children);
    let i = 0;
    while(arr.length > 0) {
      await this.waitForMs(10);
      arr.pop();
      // console.log('new-arr', arr)
      let outerArr = arr.map((span:any) => {
        return span.outerHTML
      })
      let joined = outerArr.join("")
      // console.log('joined', joined)
      ne.innerHTML = joined;
      // $(el).html(letters.join(""));
    }
  }
  
  waitForMs(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  // pauseTagline(evt: any) {
  //   console.log('hst', evt)
  //   this.shouldAnimateTagline = !this.shouldAnimateTagline
  //   this.detectChanges()
  // }

  // htmlFromRichText(richText: any) {
  //   if (richText === undefined || richText === null || richText.nodeType !== 'document') {
  //     console.warn('ERR: htmlFromRichText', richText)
  //     return '<p>Error</p>';
  //   }
  //   return documentToHtmlString(richText);
  // }

  animationCreated(animationItem: AnimationItem): void {
    // console.log('animationCreated:', animationItem);
    this.animations = animationItem
    // animationItem.goToAndStop(3, false)
  }

  handleConfigReady(evt: any) {
    console.log('~~ config ready', evt)
  }
  configReady() {
    console.log('~~ ~~  configReady')
  }
  dataReady() {
    console.log('~~  dataReady')
  }
  domLoaded() {
    console.log('~~  domLoaded')
    // this.initAnimations()
    window.setTimeout(() => this.initAnimations(), 1000)
    // let lottieContainers = document.getElementsByClassName('lottie-container')
    // console.log('lottieContainers', lottieContainers)

    // create({
    //   mode: 'scroll',
    //   player: '#lottie_1',
    //   actions: [
    //     {
    //       visibility: [0, 1],
    //       type: 'seek',
    //       frames: [0, 100],
    //     },
    //   ],
    // });
  }
  enterFrame(evt: any) {
    // console.log('~~  enterFrame', evt)
  }
  segmentStart(evt: any) {
    console.log('~~  segmentStart', evt)
  }
  complete(evt: any) {
    console.log('~~  complete', evt)
  }
  loopComplete(evt: any) {
    // console.log('~~  loopComplete', evt)
  }
  destroy(evt: any) {
    console.log('~~  destroy', evt)
  }
  error(evt: any) {
    console.log('~~  error', evt)
  }
  

  animationOptionsFromJSON(path: any) {
    return { path: path }
  }

  animationOptionsFromMedia(media: any) {
    // console.log('TODO: anim op', media)
    return {}
    // return { path: path }
  }

  handlePlayerReady(evt: any, index: string) {
    console.log('handlePlayerReady', evt.target)
    this.initScrollAnimation(evt.target, index)
    // window.setTimeout(() => this.initAnimations(), 1000)
  }

  handlePlayerLoad(evt: any) {
    console.log('handlePlayerLoad', evt)
    this.initAnimations()
  }

  // function LottieScrollTrigger(vars) {
  //   let playhead = { frame: 0 },
  //     target = gsap.utils.toArray(vars.target)[0],
  //     speeds = { slow: "+=2000", medium: "+=1000", fast: "+=500" },
  //     st = {
  //       trigger: target,
  //       pin: true,
  //       start: "top top",
  //       end: speeds[vars.speed] || "+=1000",
  //       scrub: 1,
  //     },
  //     ctx = gsap.context && gsap.context(),
  //     animation = lottie.loadAnimation({
  //       container: target,
  //       renderer: vars.renderer || "svg",
  //       loop: false,
  //       autoplay: false,
  //       path: vars.path,
  //       rendererSettings: vars.rendererSettings || {
  //         preserveAspectRatio: "xMidYMid slice",
  //       },
  //     });
  //   for (let p in vars) {
  //     // let users override the ScrollTrigger defaults
  //     st[p] = vars[p];
  //   }
  //   animation.addEventListener("DOMLoaded", function () {
  //     let createTween = function () {
  //       animation.frameTween = gsap.to(playhead, {
  //         frame: animation.totalFrames - 1,
  //         ease: "none",
  //         onUpdate: () => animation.goToAndStop(playhead.frame, true),
  //         scrollTrigger: st,
  //       });
  //       return () => animation.destroy && animation.destroy();
  //     };
  //     ctx && ctx.add ? ctx.add(createTween) : createTween();
  //     // in case there are any other ScrollTriggers on the page and the loading of this Lottie asset caused layout changes
  //     ScrollTrigger.sort();
  //     ScrollTrigger.refresh();
  //   });
  //   return animation;
  // }

  // LottieScrollTrigger({
  //   target: "#animationWindow",
  //   path: "https://assets.codepen.io/35984/tapered_hello.json",
  //   speed: "medium",
  //   scrub: 2, // seconds it takes for the playhead to "catch up"
  //   // you can also add ANY ScrollTrigger values here too, like trigger, start, end, onEnter, onLeave, onUpdate, etc. See /docs/v3/Plugins/ScrollTrigger
  // });

  handleSelectService(evt: any, content: any) {
    console.log('handleSelectService', evt, content, this.homeServicesTabContent)
    let serviceSelected = content.fields['slug']
    this.serviceActive = serviceSelected == this.serviceActive ? null : serviceSelected
    this.homeServicesTabContent.nativeElement.innerHTML = this.lcpHelper.htmlFromRichText(content.fields['body'])
    this.detectChanges()
    // this.homeServicesTabContent.nativeElement.
  }

  detectChanges() {
    this.cdr.detectChanges()
  }
}
